import Row from '@components/Row';
import Skeleton from '@components/Skeleton';

function ItemCategorySkeletons() {
    return (
        <Row spacing={2}>
            {Array.from({ length: 5 }).map((_, idx) => (
                <ItemCategorySkeleton key={`item-category-sk-${idx}`} />
            ))}
        </Row>
    );
}

function ItemCategorySkeleton() {
    return (
        <Skeleton width={80}
            height={40}
            shape='block' />
    );
}

export default ItemCategorySkeletons;
